$(document).ready(function(){

  //Открывает меню на мобильной версии
  $('#btn_openMenuXS').click(function(event){
    event.preventDefault()
    var btn = $(this),
        menu = $('#menu');
    if(btn.hasClass('open')){
      btn.removeClass('open');
      menu.removeClass('open');
    } else {
      btn.addClass('open');
      menu.addClass('open');
    }
  })

  // увеличенное изображение в модальном окне
  $('.modalGalleryItem').click(function() {
    $('#modalImgBig img').attr('src', $(this).attr('href'));
    $('#modalImgBig').modal('show');
  });
  $('#modalImgBig').on('hide.bs.modal', function (e) {
    $('#modalImgBig img').attr('src',''); 
  })

  $('select').selectpicker({
    width: '100%',
    noneSelectedText: 'Ничего не выбрано'
  });

  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover()

  $('.perfectScrollbar').perfectScrollbar({
    suppressScrollX : true
  }, 10);

  $('#package_channels').on('shown.bs.modal', function (e) {
    $('[data-toggle="tooltip"]').tooltip();
    $('.perfectScrollbar').perfectScrollbar({
      suppressScrollX : true
    }, 10);
  })

  // Маска телефона
  if($("input.phoneMask").length || $(".phoneMaskContainer input").length){
    maskPhone();
  }
})

function maskPhone(){
  var phoneEl = $(document).find('input.phoneMask,.phoneMaskContainer input'),
    phoneMaskOptions = {
      onChange: function(cep){
        // удаляем 8, если начали ввод номера с 8-ки
        if(cep.substring(0, 2) == '+8'){
          phoneEl.val(cep.replace('+8','+7'));
          phoneEl.mask("+0(000)000-00-00", phoneMaskOptions);
        }
        // добавляем +7, если начали ввод номера с 9-ки
        if(cep.substring(0, 2) == '+9'){
          phoneEl.val(cep.replace('+9','+79'));
          phoneEl.mask("+0(000)000-00-00", phoneMaskOptions);
        }
      },
    };
  phoneEl.mask("+0(000)000-00-00",phoneMaskOptions);
}

// Переключение плашки - панель администратора
function togglePanel(action){
  if(action == 'open'){
    $('#admin_panel').removeClass('close');
    $.cookie('admin_panel', 'open', { path: '/' });
  } else {
    $('#admin_panel').addClass('close');
    $.cookie('admin_panel', 'close', { path: '/' });
  }
}

/**
* блок Видеонаблюдение. Удобный и простой интерфейс.
* переключение вариантов интерфейса
*/
function setVideoSection1Item(obj,event,numItem){
  event.preventDefault();
  var parent = $(obj).parents('.video_page_section_1_carousel');

  parent.find('.video_page_section_1_carouselHandle').animate({
    left: (parseInt(numItem) * 33.3) + '%',
  }, 300, function() {
    parent.find('.video_page_section_1_carouselItem').removeClass('active');
    parent.find('.video_page_section_1_carouselItem[data-num="'+numItem+'"]').addClass('active');
    parent.find('.video_page_section_1_carouselDesc').removeClass('active');
    parent.find('.video_page_section_1_carouselDesc[data-num="'+numItem+'"]').addClass('active');
    parent.find('.video_page_section_1_carouselIMG').removeClass('active');
    parent.find('.video_page_section_1_carouselIMG[data-num="'+numItem+'"]').addClass('active');
  });
  // parent.find('.video_page_section_1_carouselHandle').css('left',(parseInt(numItem) * 33.3) + '%');

}


/**
* Загружает список каналов и открывает модальное окно
*/
function openTVTariffChannelsModal(event, tariff_id, type){
  event.preventDefault()

  var modalContent = '';
  $.get('/component/services/get_tv_tariffChannels_popup/'+tariff_id+'/'+type, function(response) {
    if(typeof response.html != 'undefined'){
      modalContent = $.parseHTML(response.html);
      // modalContent = $('<div/>').html(modalContent).text();
      $('#package_channels .modal-body').html(modalContent);
      $('#package_channels').modal('show');
    }
  }, 'json');

}

/**
* Страница Видеонаблюдение. 
* При выборе абонемента меняет абонентскую плату
*/
function setVideoTariffPrice(obj){
  var select = $(obj),
      abonement_id = parseInt(select.val()),
      priceBlock = $(document).find('.tariff_abonpay_'+abonement_id);

  // скрываем все блоки с ценами
  $(document).find('[class^="tariff_abonpay_"').hide();
  // открываем текущую цену
  priceBlock.show();  
  // для абонемента отображаем зачеркнутую базовую стоимость
  if(abonement_id == 0){
    priceBlock.parents('.video_tariffs_price').removeClass('video_tariffs_price_abonement');
  } else {
    priceBlock.parents('.video_tariffs_price').addClass('video_tariffs_price_abonement');    
  }
  
  $(document).find('[name="abonement_id"]').val(abonement_id);
}

// Смена города
function changeCity(obj,reload){
  var city_id = ($(obj).attr('name') == 'city' ? $(obj).find(':selected').data('id')  : $(obj).val()),
      city = $(obj).find(':selected').text(),
      href = $(obj).find(':selected').data('href');
  // Если не Челябинск записываем в куки и перезагружаем
  $.cookie('city', city, { path: '/' });
  $.cookie('city_id', city_id, { path: '/' });

  if (reload !== false){
    if ($('body').hasClass('error_404')){
      document.location = '/';
    } else {
      document.location.reload();
    }
  }
}

/*
* Откр/Закр блока с контентом
*/
function toggleContentBlock(obj,event){
  event.preventDefault();

  var elBtn = $(obj),
      content_text = elBtn.parents('.content_text'),
      content_text_hide = content_text.find('.content_text_hide');

  if(content_text.hasClass('open')){
    content_text.removeClass('open');
    content_text_hide.slideUp(300,function(){
      // $(document).scrollTop(content_text.position().top);
      elBtn.text('Подробнее');
    });
  } else {
    content_text.addClass('open');
    content_text_hide.slideDown(300,function(){
      elBtn.text('Свернуть');
    });
  }
}

const getCookie = (name) => {
  const matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([\\.$?*|{}\\(\\)\\[\]\\\\/\\+^])/g, '\\$1') +
        '=([^;]*)'
    )
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}

function submitCoockie() {
  document.cookie = `acceptCookie=true; expires=${new Date(
    new Date().setFullYear(new Date().getFullYear() + 1)
  ).toUTCString()}`
  $('.coockie-modal').hide()
}

window.onload = function() {
  if (this.location.href.includes('#')) {
    const cities = {
      pervouralsk: '9',
      asbest: '8'
    }
    const city = this.location.href.split('#')[1]
    
    if (cities[city] && $('[name = city_id]').val() !== cities[city]) {
      this.history.pushState(null, null, this.location.href.split('#')[0])
      $('[name = city_id]').val(cities[city]).change()
    }  
  }

  if (!getCookie('acceptCookie')) {
    const confirmModal = $(`
  <div class="coockie-modal"><div class="content">Для повышения удобства работы с сайтом ООО "Гарант" использует файлы cookie. Продолжая использовать наш сайт, вы принимаете условия <a href="https://www.garant-multicom.ru/uploads/Politika_obrabotki_01.01.20_Garant.pdf" target="_blank" >Политики в отношении обработки персональных данных.</a> Если вы не хотите, чтобы пользовательские данные обрабатывались, отключите cookie в настройках браузера.</div><input type="submit" onClick="submitCoockie();" value="Принять" class="btn btn-blue btn-block b-btn b-btn_big"
  onClick="submitForm(this);" /></div>
  `)
  $('body').append(confirmModal)
  }
};